import { render, staticRenderFns } from "./dust.vue?vue&type=template&id=2edc422a"
import script from "./dust.vue?vue&type=script&lang=js"
export * from "./dust.vue?vue&type=script&lang=js"
import style0 from "./dust.vue?vue&type=style&index=0&id=2edc422a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports